import * as i0 from "@angular/core";
export class DateInterceptorService {
    constructor() { }
}
DateInterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DateInterceptorService_Factory() { return new DateInterceptorService(); }, token: DateInterceptorService, providedIn: "root" });
